module.exports = __webpack_public_path__ + "2164619bc384d0991983df0c3f67ee3a.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/FK.svg
// module id = LVYh
// module chunks = 0